// extracted by mini-css-extract-plugin
export var cardSelected = "_i9-2";
export var image = "_i9-1";
export var table = "_i9-0";